/* Loop 2 R2: quick-order pad (sections/quick-order.liquid). Needs assets/imm.js first (window.immGetIndex,
   immSearch, immModel, immCompact, immQuoteRender, immToast). Writes to the same quote list (localStorage imm_quote).
   Lines that are not in the catalogue can go to the list as free-text lines ({u:''}); the drawer sends them as text. */
(function () {
  var root = document.querySelector('[data-imm-qo]');
  if (!root || !window.immGetIndex || !window.immSearch) return;
  var KEY = 'imm_quote', DRAFT = 'imm_qo_text';
  var ta = root.querySelector('[data-imm-qo-text]'), status = root.querySelector('[data-imm-qo-status]');
  var res = root.querySelector('[data-imm-qo-results]'), ulM = root.querySelector('[data-imm-qo-matched]');
  var ulS = root.querySelector('[data-imm-qo-sugg]'), sWrap = root.querySelector('[data-imm-qo-sugg-wrap]');
  var ulX = root.querySelector('[data-imm-qo-miss]'), xWrap = root.querySelector('[data-imm-qo-miss-wrap]');
  var addBtn = root.querySelector('[data-imm-qo-add]'), nAdd = root.querySelector('[data-imm-qo-nadd]');
  var rows = [], misses = [], pasted = {};   // pasted: qty this check already put in the list per URL
  var C = window.immCompact;
  var INT = /^\d{1,4}$/;

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(v) { return window.immMoney ? window.immMoney(v) : '$' + v; }
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} if (window.immQuoteRender) window.immQuoteRender(); }
  function clampQ(n) { n = parseInt(n, 10); return isNaN(n) || n < 1 ? 1 : Math.min(n, 9999); }

  /* leading quantity ("2 x 87V", "2 87V"), but not when the line also ends in a bare number ("1587 FC 2" = qty 2) */
  function leadQty(line) {
    var m = /^(\d{1,4})\s*(?:x|pcs?|ea|units?)\s+(.+)$/i.exec(line);
    if (!m) { m = /^(\d{1,4})\s+(.+)$/.exec(line); if (m && !(/\d/.test(m[2]) && /[a-z]/i.test(m[2]))) m = null; }
    return m && !/\s\d{1,4}$/.test(m[2]) ? m : null;
  }
  /* one pasted line -> { part, q } or null */
  function parseLine(line) {
    line = line.replace(/ /g, ' ').trim().replace(/^(?:[-*•]|\d{1,3}[.)])\s+/, '');   // "1. " / "1) " / "- " bullets first
    if (!line) return null;
    if (!/\d/.test(line) && /^(part|item|model|sku|description|qty|quantity|no\.?)\b/i.test(line)) return null;  // header row
    var cells = line.split(/\t|;|,(?!\d{3}(?:\D|$))/).map(function (c) { return c.trim(); }).filter(Boolean);
    var part = '', q = 1, m;
    if (cells.length > 1) {
      var last = cells[cells.length - 1].replace(/\s*(pcs?|ea|units?)\.?$/i, '').replace(/^(\d{1,2}),(\d{3})$/, '$1$2');
      if (INT.test(last)) { q = last; cells.pop(); part = cells.join(' '); }
      else if (INT.test(cells[0])) { q = cells.shift(); part = cells.join(' '); }
      else part = cells.join(' ');
    } else if ((m = leadQty(line))) {
      q = m[1]; part = m[2];
    } else if ((m = /^(.+?)\s+(?:x\s*|qty:?\s*)?(\d{1,4})\s*(?:pcs?|ea|units?)?\.?$/i.exec(line)) && /\d/.test(m[1])) {
      part = m[1]; q = m[2];
    } else part = line;
    part = part.trim();
    return part ? { part: part, q: clampQ(q) } : null;
  }

  function isExact(p, part) {
    var c = C(part), m = C(window.immModel(p)), v = C(p[2]);
    if (!c || c.length < 2) return false;
    if (c === m || c === C(p[6]) || (m && c === v + m)) return true;
    var first = C(String(p[2]).split(' ')[0]);
    if (m && first && c === first + m) return true;
    var pre = /^([a-z]{2,4})[-\s]+(.*\d.*)$/i.exec(part);   // ordering prefix: "FLK-87-5" = Fluke 87-5
    return !!(pre && m && C(pre[2]) === m && v.charAt(0) === pre[1].charAt(0).toLowerCase());
  }

  function check() {
    var parsed = [];
    ta.value.split(/\r?\n/).forEach(function (l) { var r = parseLine(l); if (r) parsed.push(r); });
    if (!parsed.length) { status.innerHTML = 'Nothing to check yet. Paste one part number per line.'; res.hidden = true; return; }
    if (parsed.length > 200) parsed = parsed.slice(0, 200);
    status.innerHTML = 'Checking ' + parsed.length + ' line' + (parsed.length === 1 ? '' : 's') + '&hellip;';
    window.immGetIndex().then(function (d) {
      if (!d.length) { status.innerHTML = 'The catalogue index did not load. Reload the page, or send the list with the quote form.'; return; }
      rows = []; misses = []; pasted = {};
      parsed.forEach(function (ln) {
        var r = window.immSearch(d, ln.part, 40);
        var ex = r.list.filter(function (p) { return isExact(p, ln.part); }).slice(0, 6);
        if (ex.length) rows.push({ part: ln.part, q: ln.q, cands: ex, pick: 0, exact: true, use: true });
        else if (r.total) rows.push({ part: ln.part, q: ln.q, cands: r.list.slice(0, 4), pick: 0, exact: false, use: false });
        else misses.push(ln);
      });
      render();
    });
  }

  function rowHtml(r, i) {
    var p = r.cands[r.pick], mdl = window.immModel(p);
    var sel = r.cands.length > 1 ? '<label class="imm-qo__pick"><span class="imm-visually-hidden">Choose the product for ' + esc(r.part) + '</span><select data-qo-pick="' + i + '">' +
      r.cands.map(function (c, k) { return '<option value="' + k + '"' + (k === r.pick ? ' selected' : '') + '>' + esc(c[0]) + ' (' + money(c[3]) + ')</option>'; }).join('') + '</select></label>' : '';
    return '<li class="imm-qo__row' + (r.use ? ' is-on' : '') + '">' +
      (r.exact ? '<span class="imm-qo__tag">Exact</span>' :
        '<label class="imm-qo__use"><input type="checkbox" data-qo-use="' + i + '"' + (r.use ? ' checked' : '') + '><span class="imm-visually-hidden">Use this match for ' + esc(r.part) + '</span></label>') +
      '<div class="imm-qo__meta"><span class="imm-qo__you">You entered: <code>' + esc(r.part) + '</code></span>' +
      '<a href="/products/' + esc(p[1]) + '" target="_blank" rel="noopener">' + esc(p[0]) + '</a>' +
      '<span class="imm-qo__sub">' + esc(p[2]) + (mdl ? ' &middot; Model ' + esc(mdl) : '') + ' &middot; list ' + money(p[3]) + ' USD</span>' + sel + '</div>' +
      '<label class="imm-qo__qty"><span class="imm-visually-hidden">Quantity for ' + esc(r.part) + '</span><input type="number" min="1" max="9999" inputmode="numeric" value="' + r.q + '" data-qo-q="' + i + '"></label></li>';
  }

  function render() {
    var ex = [], sg = [];
    rows.forEach(function (r, i) { (r.exact ? ex : sg).push(rowHtml(r, i)); });
    ulM.innerHTML = ex.join('') || '<li class="imm-qo__none">No exact matches.</li>';
    ulS.innerHTML = sg.join(''); sWrap.hidden = !sg.length;
    ulX.innerHTML = misses.map(function (m) { return '<li><code>' + esc(m.part) + '</code> &times; ' + m.q + '</li>'; }).join('');
    xWrap.hidden = !misses.length;
    root.querySelector('[data-imm-qo-nmatch]').textContent = '(' + ex.length + ')';
    root.querySelector('[data-imm-qo-nmiss]').textContent = '(' + misses.length + ')';
    var total = rows.length + misses.length;
    status.innerHTML = '<b>' + total + '</b> line' + (total === 1 ? '' : 's') + ': ' + ex.length + ' exact, ' + sg.length + ' possible, ' + misses.length + ' not found.';
    res.hidden = false; count();
  }
  function count() {
    var n = rows.filter(function (r) { return r.use; }).length;
    nAdd.textContent = n; addBtn.disabled = !n;
  }

  function addAll() {
    var a = load(), n = 0, sum = {}, meta = {}, order = [];
    // sum quantities per product for this press (two pasted lines can hit the same product)
    rows.forEach(function (r) {
      if (!r.use) return;
      var p = r.cands[r.pick], u = '/products/' + p[1];
      if (!(u in sum)) { sum[u] = 0; meta[u] = p; order.push(u); }
      sum[u] = clampQ(sum[u] + r.q);
    });
    order.forEach(function (u) {
      var p = meta[u], it = null;
      for (var k = 0; k < a.length; k++) if (a[k].u === u) it = a[k];
      // pressing Add again for the same paste sets the quantity instead of doubling it
      if (it) it.q = clampQ((it.q || 1) - (pasted[u] || 0) + sum[u]);
      else a.push({ t: p[0], u: u, i: p[4] || '', v: p[2], p: Number(p[3]).toFixed(2), q: sum[u] });
      pasted[u] = sum[u];
      n++;
    });
    save(a);
    if (window.immToast) window.immToast(n + ' item' + (n === 1 ? '' : 's') + ' added to your quote list &middot; <button type="button" data-imm-qopen>View list (' + a.length + ')</button>');
  }
  function askMisses() {
    var a = load(), list = misses.concat(rows.filter(function (r) { return !r.exact && !r.use; }));
    list.forEach(function (m) {
      var it = null;
      for (var k = 0; k < a.length; k++) if (!a[k].u && a[k].t === m.part) it = a[k];
      if (it) it.q = clampQ((it.q || 1) + m.q);
      else a.push({ t: m.part, u: '', i: '', v: 'Not in online catalogue', p: '', q: m.q });
    });
    save(a);
    if (window.immToast) window.immToast(list.length + ' text line' + (list.length === 1 ? '' : 's') + ' added. We quote them by part number &middot; <button type="button" data-imm-qopen>View list</button>');
  }

  root.querySelector('[data-imm-qo-check]').addEventListener('click', check);
  root.querySelector('[data-imm-qo-clear]').addEventListener('click', function () {
    ta.value = ''; rows = []; misses = []; res.hidden = true;
    status.innerHTML = 'Cleared. Paste a new list.';
    try { localStorage.removeItem(DRAFT); } catch (e) {}
    ta.focus();
  });
  ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); check(); } });
  ta.addEventListener('input', function () { try { localStorage.setItem(DRAFT, ta.value.slice(0, 8000)); } catch (e) {} });
  ta.addEventListener('focus', function () { window.immGetIndex(); }, { once: true });
  addBtn.addEventListener('click', addAll);
  root.querySelector('[data-imm-qo-ask]').addEventListener('click', askMisses);
  res.addEventListener('change', function (e) {
    var t = e.target, i;
    if ((i = t.getAttribute('data-qo-use')) !== null) { rows[i].use = t.checked; t.closest('li').classList.toggle('is-on', t.checked); count(); }
    else if ((i = t.getAttribute('data-qo-q')) !== null) { rows[i].q = clampQ(t.value); t.value = rows[i].q; }
    else if ((i = t.getAttribute('data-qo-pick')) !== null) { rows[i].pick = +t.value; t.closest('li').outerHTML = rowHtml(rows[i], +i); }
  });
  try { var dr = localStorage.getItem(DRAFT); if (dr && !ta.value) ta.value = dr; } catch (e) {}
  try { var qp = new URLSearchParams(location.search).get('items'); if (qp) { ta.value = qp.slice(0, 8000); check(); } } catch (e) {}
})();
